import axios from 'axios';

import { requestInterceptor } from '../interceptors/auth0.interceptor';

const HTTP_CONTENT_TYPE = {
  'Content-Type': 'application/json',
};

export const ERROR_STATUS_CODE = {
  NOT_FOUND: 400,
  UNAUTHENTICATED: 401,
  FORBIDDEN: 403,
  NOT_TRACKABLE: 404,
  INTERNAL_ERROR: 500,
  SERVICE_UNAVAILABLE: 503,
  TIMEOUT: 504,
};

const axiosInstance = axios.create({
  withCredentials: true,
  headers: {
    ...HTTP_CONTENT_TYPE,
  },
});

requestInterceptor(axiosInstance);

export default axiosInstance;
